import { createApi } from "redux-future-middleware";
import { requestApi } from "core/api";
import * as types from "./types";

export const submitPayment = createApi({
  name: types.SUBMIT_PAYMENT,
  request: ({ body }) =>
    requestApi({
      path: "/billing/cards/",
      method: "POST",
      body
    })
});

export const getCards = createApi({
  name: types.GET_CARDS,
  request: () =>
    requestApi({
      path: "/billing/cards/",
      method: "GET"
    })
});

export const deleteCard = createApi({
  name: types.DELETE_CARD,
  request: id =>
    requestApi({
      path: `/billing/cards/${id}/`,
      method: "DELETE"
    })
});

export const getInvoice = createApi({
  name: types.GET_INVOICE,
  request: ({ orderId }) =>
    requestApi({
      path: `billing/invoices/?order_no=${orderId}`,
      method: "GET"
    })
});

export const checkout = createApi({
  name: types.CHECKOUT,
  request: ({ bookingId, cardId, promo_code }) =>
    requestApi({
      method: "POST",
      path: `/insiders/bookings/${bookingId}/checkout/`,
      body: (cardId && {
        card_id: cardId,
        promo_code
      }) || { promo_code }
    })
});

export const createInsiderPaymentInfo = createApi({
  name: types.CREATE_INSIDER_PAYMENT_INFO,
  request: ({ code }) =>
    requestApi({
      method: "POST",
      path: `/billing/payable-accounts/`,
      body: {
        authorization_code: code
      }
    })
});

export const billingInfo = createApi({
  name: types.BILLING_INFO,
  request: () =>
    requestApi({
      method: "GET",
      path: "/billing/payable-accounts/current/"
    })
});

export const billingAccountBalance = createApi({
  name: types.BILLING_ACCOUNT_BALANCE,
  request: () =>
    requestApi({
      path: `/billing/payable-accounts/current/login-link/`,
      method: "GET"
    })
});



// WEBPACK FOOTER //
// ./src/modules/payment/api.js